module.exports = __webpack_public_path__ + "static/media/valor3_3.2376cf7e.png";